<template>
  <div data-app>
    <luci-btn-icon :config="backBtnConfig" @callback="$router.push({ name: 'TerritoryList' })"></luci-btn-icon>

    <v-alert v-if="error" :value="true" color="error" icon="error" class="error-container">
      <span class="error-span luci-text white--text">{{ error }}</span>
    </v-alert>

    <div v-if="isLoading" class="loading">
      <img src="../../assets/images/icons/loading-pmc.gif" alt="'Loading">
    </div>

    <luci-form v-if="!isLoading" :config="formConfig" v-model="formData" @submit="submitForm" @reset="resetForm" @callback="$router.push({ name: 'TerritoryList' })" ></luci-form>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'

import variables from '../../helpers/variables'

const { mapGetters, mapActions } = createNamespacedHelpers('territory/create')

export default {
  data () {
    return {
      backBtnConfig: variables.backBtnIconOptions,
      formData: { name: '', slug: '' }
    }
  },
  computed: {
    ...mapGetters(['error', 'isLoading', 'created', 'violations']),
    formConfig () {
      return (
        {
          name: 'form-add-territory',
          title: 'Details',
          description: 'To add a new territory please fill in the form below',
          showButtonAsIcon: true,
          buttons: variables.formButtons,
          fields: [
            {
              order: 1,
              element: 'input',
              required: true,
              name: 'name',
              label: 'name',
              inputConfig: { type: 'text', placeholder: 'Please enter territory name', clearable: true }
            },
            {
              order: 2,
              element: 'input',
              required: true,
              name: 'slug',
              label: 'slug',
              inputConfig: { type: 'text', placeholder: 'Please enter territory slug', clearable: true }
            }
          ]
        }
      )
    }
  },
  watch: {
    // eslint-disable-next-line object-shorthand,func-names
    created: function (created) {
      if (!created) {
        return
      }
      this.$router.push({ name: 'TerritoryList' })
    }
  },
  created () {
    this.reset()
  },
  methods: {
    ...mapActions(['reset', 'create']),
    resetForm () {
      this.reset()
      this.formData = { name: '', slug: '' }
    },
    submitForm () {
      this.create(this.formData)
    }
  }
}
</script>
